import { useMutation } from '@tanstack/react-query';
import { modemApis } from '../../../../../../shared/apis/modem/apis';
import { handleError } from '../../../../../ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../../shared/types';

export default function useActivateSlackAlert() {
  return useMutation(modemApis.postActivateSlackAlert, {
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
